export enum Value {
    Yes = 'yes',
    No = 'no',
    Propose = 'propose',
    INAPPLICABLE = 'inapplicable',
    UNKNOWN = 'unknown',
}
